import {cpm, types, effectiveness, pokemon_data} from "./pokemon_data.js";

export function effectivity(defender_types, attack) {
    // console.log(attack);
    let effs = effectiveness;
    let eff = 1;
    for (let i = 0; i < defender_types.length; i++) {
        if(defender_types[i] != null)
            eff *= parseFloat(effs[attack][types[defender_types[i]]]);
    }
    return eff
}
export function stats(id,level,ivs){
    let poke = pokemon_data[id][5];
    let l = 2 * parseFloat(level);
    // debugger // eslint-disable-line
    let currSta = (poke[0] + parseInt(ivs[2])) * cpm[(l - 1) < 1 ? 1 : l - 1];
    let currAtt = (poke[1] + parseInt(ivs[0])) * cpm[(l - 1) < 1 ? 1 : l - 1];
    let currDef = (poke[2] + parseInt(ivs[1])) * cpm[(l - 1) < 1 ? 1 : l - 1];
    return [currAtt, currDef, currSta]
}
export function hp(id,level,ivs){
    let poke = pokemon_data[id][5];
    let l = 2 * parseFloat(level);
    return Math.max(10, (Math.floor((poke[0] + parseInt(ivs[2])) * cpm[l - 1])));
}
export function  damage(att, def, power, multipliers) {
    return Math.floor(0.5 * power * (att / def) * multipliers) + 1
}

export default {effectivity, damage,hp}